import { createSlice } from '@reduxjs/toolkit';
import { getLocalStorageData } from '../../shared/commonFunction';

const ads = getLocalStorageData('ads') || true;
const initialState = {
    isAdsShow: ads,
};

export const adsSlice = createSlice({
    name: 'ads',
    initialState,
    reducers: {
        setAdsState: (state, action) => {
            state.isAdsShow = action.payload;
        },
    },
});

export const { setAdsState } = adsSlice.actions;
export default adsSlice.reducer;
